import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 loader. No-op if REACT_APP_GA_MEASUREMENT_ID is empty.
 * Tracks page_view on every route change automatically.
 */
export function Analytics() {
  const { pathname, search } = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  // Inject gtag once
  useEffect(() => {
    if (!measurementId) return;
    if (document.getElementById("ga4-script")) return;

    const script = document.createElement("script");
    script.id = "ga4-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    // Manual page_view tracking below (send_page_view: false avoids duplicates)
    gtag("config", measurementId, { send_page_view: false });
  }, [measurementId]);

  // Track page_view on route change
  useEffect(() => {
    if (!measurementId) return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search, measurementId]);

  return null;
}

// Utility to fire custom conversion events elsewhere
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
